<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-sms__banneradvertise">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.name" placeholder="名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
                <!--        </el-form-item>-->
                <el-form-item>
                    <el-button v-if="$hasPermission('sms:banneradvertise:save')" type="primary"
                               @click="addOrUpdateHandle()">{{ $t('add') }}
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="$hasPermission('sms:banneradvertise:delete')" type="danger"
                               @click="deleteHandle()">{{ $t('deleteBatch') }}
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="categoryId" label="类目ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="name" label="名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="picture" label="图片地址" header-align="center" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.picture" alt="" width="100" height="100">
                    </template>
                </el-table-column>
                <el-table-column prop="linkUrl" label="链接地址" header-align="center" align="center"></el-table-column>
                <el-table-column prop="note" label="备注" header-align="center" align="center"></el-table-column>
                <el-table-column prop="deleteStatus" label="删除状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.deleteStatus===1" type="success">未删除</el-tag>
                        <el-tag v-else-if="scope.row.deleteStatus===2" type="success">未删除</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>

                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('sms:banneradvertise:update')" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
                        <el-button v-if="$hasPermission('sms:banneradvertise:delete')" type="text" size="small"
                                   @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './banneradvertise-add-or-update'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/sms/banneradvertise/page',
                    getDataListIsPage: true,
                    exportURL: '/sms/banneradvertise/export',
                    deleteURL: '/sms/banneradvertise',
                    deleteIsBatch: true
                },
                dataForm: {
                    name: ''
                }
            }
        },
        components: {
            AddOrUpdate
        }
    }
</script>
